import { render, staticRenderFns } from "./propertyTable.vue?vue&type=template&id=32209772&"
import script from "./propertyTable.vue?vue&type=script&lang=js&"
export * from "./propertyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports